export class PrimeIcons {
    public static readonly ALIGN_CENTER = 'pi pi-align-center';
    public static readonly ALIGN_JUSTIFY = 'pi pi-align-justify';
    public static readonly ALIGN_LEFT = 'pi pi-align-left';
    public static readonly ALIGN_RIGHT = 'pi pi-align-right';
    public static readonly AMAZON = 'pi pi-amazon';
    public static readonly ANDROID = 'pi pi-android';
    public static readonly ANGLE_DOUBLE_DOWN = 'pi pi-angle-double-down';
    public static readonly ANGLE_DOUBLE_LEFT = 'pi pi-angle-double-left';
    public static readonly ANGLE_DOUBLE_RIGHT = 'pi pi-angle-double-right';
    public static readonly ANGLE_DOUBLE_UP = 'pi pi-angle-double-up';
    public static readonly ANGLE_DOWN = 'pi pi-angle-down';
    public static readonly ANGLE_LEFT = 'pi pi-angle-left';
    public static readonly ANGLE_RIGHT = 'pi pi-angle-right';
    public static readonly ANGLE_UP = 'pi pi-angle-up';
    public static readonly APPLE = 'pi pi-apple';
    public static readonly ARROWS_ALT = 'pi pi-arrows-alt';
    public static readonly ARROW_CIRCLE_DOWN = 'pi pi-arrow-circle-down';
    public static readonly ARROW_CIRCLE_LEFT = 'pi pi-arrow-circle-left';
    public static readonly ARROW_CIRCLE_RIGHT = 'pi pi-arrow-circle-right';
    public static readonly ARROW_CIRCLE_UP = 'pi pi-arrow-circle-up';
    public static readonly ARROW_DOWN = 'pi pi-arrow-down';
    public static readonly ARROW_DOWN_LEFT = 'pi pi-arrow-down-left';
    public static readonly ARROW_DOWN_RIGHT = 'pi pi-arrow-down-right';
    public static readonly ARROW_LEFT = 'pi pi-arrow-left';
    public static readonly ARROW_RIGHT_ARROW_LEFT = 'pi pi-arrow-right-arrow-left';
    public static readonly ARROW_RIGHT = 'pi pi-arrow-right';
    public static readonly ARROW_UP = 'pi pi-arrow-up';
    public static readonly ARROW_UP_LEFT = 'pi pi-arrow-up-left';
    public static readonly ARROW_UP_RIGHT = 'pi pi-arrow-up-right';
    public static readonly ARROW_H = 'pi pi-arrows-h';
    public static readonly ARROW_V = 'pi pi-arrows-v';
    public static readonly AT = 'pi pi-at';
    public static readonly BACKWARD = 'pi pi-backward';
    public static readonly BAN = 'pi pi-ban';
    public static readonly BARS = 'pi pi-bars';
    public static readonly BELL = 'pi pi-bell';
    public static readonly BITCOIN = 'pi pi-bitcoin';
    public static readonly BOLT = 'pi pi-bolt';
    public static readonly BOOK = 'pi pi-book';
    public static readonly BOOKMARK = 'pi pi-bookmark';
    public static readonly BOOKMARK_FILL = 'pi pi-bookmark-fill';
    public static readonly BOX = 'pi pi-box';
    public static readonly BRIEFCASE = 'pi pi-briefcase';
    public static readonly BUILDING = 'pi pi-building';
    public static readonly CALCULATOR = 'pi pi-calculator';
    public static readonly CALENDAR = 'pi pi-calendar';
    public static readonly CALENDAR_MINUS = 'pi pi-calendar-minus';
    public static readonly CALENDAR_PLUS = 'pi pi-calendar-plus';
    public static readonly CALENDAR_TIMES = 'pi pi-calendar-times';
    public static readonly CAMERA = 'pi pi-camera';
    public static readonly CAR = 'pi pi-car';
    public static readonly CARET_DOWN = 'pi pi-caret-down';
    public static readonly CARET_LEFT = 'pi pi-caret-left';
    public static readonly CARET_RIGHT = 'pi pi-caret-right';
    public static readonly CARET_UP = 'pi pi-caret-up';
    public static readonly CART_PLUS = 'pi pi-cart-plus';
    public static readonly CHART_BAR = 'pi pi-chart-bar';
    public static readonly CHART_LINE = 'pi pi-chart-line';
    public static readonly CHART_PIE = 'pi pi-chart-pie';
    public static readonly CHECK = 'pi pi-check';
    public static readonly CHECK_CIRCLE = 'pi pi-check-circle';
    public static readonly CHECK_SQUARE = 'pi pi-check-square';
    public static readonly CHEVRON_CIRCLE_DOWN = 'pi pi-chevron-circle-down';
    public static readonly CHEVRON_CIRCLE_LEFT = 'pi pi-chevron-circle-left';
    public static readonly CHEVRON_CIRCLE_RIGHT = 'pi pi-chevron-circle-right';
    public static readonly CHEVRON_CIRCLE_UP = 'pi pi-chevron-circle-up';
    public static readonly CHEVRON_DOWN = 'pi pi-chevron-down';
    public static readonly CHEVRON_LEFT = 'pi pi-chevron-left';
    public static readonly CHEVRON_RIGHT = 'pi pi-chevron-right';
    public static readonly CHEVRON_UP = 'pi pi-chevron-up';
    public static readonly CIRCLE = 'pi pi-circle';
    public static readonly CIRCLE_FILL = 'pi pi-circle-fill';
    public static readonly CLOCK = 'pi pi-clock';
    public static readonly CLONE = 'pi pi-clone';
    public static readonly CLOUD = 'pi pi-cloud';
    public static readonly CLOUD_DOWNLOAD = 'pi pi-cloud-download';
    public static readonly CLOUD_UPLOAD = 'pi pi-cloud-upload';
    public static readonly CODE = 'pi pi-code';
    public static readonly COG = 'pi pi-cog';
    public static readonly COMMENT = 'pi pi-comment';
    public static readonly COMMENTS = 'pi pi-comments';
    public static readonly COMPASS = 'pi pi-compass';
    public static readonly COPY = 'pi pi-copy';
    public static readonly CREDIT_CARD = 'pi pi-credit-card';
    public static readonly DATABASE = 'pi pi-database';
    public static readonly DESKTOP = 'pi pi-desktop';
    public static readonly DELETE_LEFT = 'pi pi-delete-left';
    public static readonly DIRECTIONS = 'pi pi-directions';
    public static readonly DIRECTIONS_ALT = 'pi pi-directions-alt';
    public static readonly DISCORD = 'pi pi-discord';
    public static readonly DOLLAR = 'pi pi-dollar';
    public static readonly DOWNLOAD = 'pi pi-download';
    public static readonly EJECT = 'pi pi-eject';
    public static readonly ELLIPSIS_H = 'pi pi-ellipsis-h';
    public static readonly ELLIPSIS_V = 'pi pi-ellipsis-v';
    public static readonly ENVELOPE = 'pi pi-envelope';
    public static readonly ERASER = 'pi pi-eraser';
    public static readonly EURO = 'pi pi-euro';
    public static readonly EXCLAMATION_CIRCLE = 'pi pi-exclamation-circle';
    public static readonly EXCLAMATION_TRIANGLE = 'pi pi-exclamation-triangle';
    public static readonly EXTERNAL_LINK = 'pi pi-external-link';
    public static readonly EYE = 'pi pi-eye';
    public static readonly EYE_SLASH = 'pi pi-eye-slash';
    public static readonly FACEBOOK = 'pi pi-facebook';
    public static readonly FAST_BACKWARD = 'pi pi-fast-backward';
    public static readonly FAST_FORWARD = 'pi pi-fast-forward';
    public static readonly FILE = 'pi pi-file';
    public static readonly FILE_EDIT = 'pi pi-file-edit';
    public static readonly FILE_IMPORT = 'pi pi-file-import';
    public static readonly FILE_PDF = 'pi pi-file-pdf';
    public static readonly FILE_EXCEL = 'pi pi-file-excel';
    public static readonly FILE_EXPORT = 'pi pi-file-export';
    public static readonly FILE_WORD = 'pi pi-file-word';
    public static readonly FILTER = 'pi pi-filter';
    public static readonly FILTER_FILL = 'pi pi-filter-fill';
    public static readonly FILTER_SLASH = 'pi pi-filter-slash';
    public static readonly FLAG = 'pi pi-flag';
    public static readonly FLAG_FILL = 'pi pi-flag-fill';
    public static readonly FOLDER = 'pi pi-folder';
    public static readonly FOLDER_OPEN = 'pi pi-folder-open';
    public static readonly FORWARD = 'pi pi-forward';
    public static readonly GIFT = 'pi pi-gift';
    public static readonly GITHUB = 'pi pi-github';
    public static readonly GLOBE = 'pi pi-globe';
    public static readonly GOOGLE = 'pi pi-google';
    public static readonly HASHTAG = 'pi pi-hashtag';
    public static readonly HEART = 'pi pi-heart';
    public static readonly HEART_FILL = 'pi pi-heart-fill';
    public static readonly HISTORY = 'pi pi-history';
    public static readonly HOME = 'pi pi-home';
    public static readonly HOURGLASS = 'pi pi-hourglass';
    public static readonly ID_CARD = 'pi pi-id-card';
    public static readonly IMAGE = 'pi pi-image';
    public static readonly IMAGES = 'pi pi-images';
    public static readonly INBOX = 'pi pi-inbox';
    public static readonly INFO = 'pi pi-info';
    public static readonly INFO_CIRCLE = 'pi pi-info-circle';
    public static readonly INSTAGRAM = 'pi pi-instagram';
    public static readonly KEY = 'pi pi-key';
    public static readonly LANGUAGE = 'pi pi-language';
    public static readonly LINK = 'pi pi-link';
    public static readonly LINKEDIN = 'pi pi-linkedin';
    public static readonly LIST = 'pi pi-list';
    public static readonly LOCK = 'pi pi-lock';
    public static readonly LOCK_OPEN = 'pi pi-lock-open';
    public static readonly MAP = 'pi pi-map';
    public static readonly MAP_MARKER = 'pi pi-map-marker';
    public static readonly MEGAPHONE = 'pi pi-megaphone';
    public static readonly MICROPHONE = 'pi pi-microphone';
    public static readonly MICROSOFT = 'pi pi-microsoft';
    public static readonly MINUS = 'pi pi-minus';
    public static readonly MINUS_CIRCLE = 'pi pi-minus-circle';
    public static readonly MOBILE = 'pi pi-mobile';
    public static readonly MONEY_BILL = 'pi pi-money-bill';
    public static readonly MOON = 'pi pi-moon';
    public static readonly PALETTE = 'pi pi-palette';
    public static readonly PAPERCLIP = 'pi pi-paperclip';
    public static readonly PAUSE = 'pi pi-pause';
    public static readonly PAYPAL = 'pi pi-paypal';
    public static readonly PENCIL = 'pi pi-pencil';
    public static readonly PERCENTAGE = 'pi pi-percentage';
    public static readonly PHONE = 'pi pi-phone';
    public static readonly PLAY = 'pi pi-play';
    public static readonly PLUS = 'pi pi-plus';
    public static readonly PLUS_CIRCLE = 'pi pi-plus-circle';
    public static readonly POUND = 'pi pi-pound';
    public static readonly POWER_OFF = 'pi pi-power-off';
    public static readonly PRIME = 'pi pi-prime';
    public static readonly PRINT = 'pi pi-print';
    public static readonly QRCODE = 'pi pi-qrcode';
    public static readonly QUESTION = 'pi pi-question';
    public static readonly QUESTION_CIRCLE = 'pi pi-question-circle';
    public static readonly REDDIT = 'pi pi-reddit';
    public static readonly REFRESH = 'pi pi-refresh';
    public static readonly REPLAY = 'pi pi-replay';
    public static readonly REPLY = 'pi pi-reply';
    public static readonly SAVE = 'pi pi-save';
    public static readonly SEARCH = 'pi pi-search';
    public static readonly SEARCH_MINUS = 'pi pi-search-minus';
    public static readonly SEARCH_PLUS = 'pi pi-search-plus';
    public static readonly SEND = 'pi pi-send';
    public static readonly SERVER = 'pi pi-server';
    public static readonly SHARE_ALT = 'pi pi-share-alt';
    public static readonly SHIELD = 'pi pi-shield';
    public static readonly SHOPPING_BAG = 'pi pi-shopping-bag';
    public static readonly SHOPPING_CART = 'pi pi-shopping-cart';
    public static readonly SIGN_IN = 'pi pi-sign-in';
    public static readonly SIGN_OUT = 'pi pi-sign-out';
    public static readonly SITEMAP = 'pi pi-sitemap';
    public static readonly SLACK = 'pi pi-slack';
    public static readonly SLIDERS_H = 'pi pi-sliders-h';
    public static readonly SLIDERS_V = 'pi pi-sliders-v';
    public static readonly SORT = 'pi pi-sort';
    public static readonly SORT_ALPHA_DOWN = 'pi pi-sort-alpha-down';
    public static readonly SORT_ALPHA_ALT_DOWN = 'pi pi-sort-alpha-alt-down';
    public static readonly SORT_ALPHA_UP = 'pi pi-sort-alpha-up';
    public static readonly SORT_ALPHA_ALT_UP = 'pi pi-sort-alpha-alt-up';
    public static readonly SORT_ALT = 'pi pi-sort-alt';
    public static readonly SORT_ALT_SLASH = 'pi pi-sort-slash';
    public static readonly SORT_AMOUNT_DOWN = 'pi pi-sort-amount-down';
    public static readonly SORT_AMOUNT_DOWN_ALT = 'pi pi-sort-amount-down-alt';
    public static readonly SORT_AMOUNT_UP = 'pi pi-sort-amount-up';
    public static readonly SORT_AMOUNT_UP_ALT = 'pi pi-sort-amount-up-alt';
    public static readonly SORT_DOWN = 'pi pi-sort-down';
    public static readonly SORT_NUMERIC_DOWN = 'pi pi-sort-numeric-down';
    public static readonly SORT_NUMERIC_ALT_DOWN = 'pi pi-sort-numeric-alt-down';
    public static readonly SORT_NUMERIC_UP = 'pi pi-sort-numeric-up';
    public static readonly SORT_NUMERIC_ALT_UP = 'pi pi-sort-numeric-alt-up';
    public static readonly SORT_UP = 'pi pi-sort-up';
    public static readonly SPINNER = 'pi pi-spinner';
    public static readonly STAR = 'pi pi-star';
    public static readonly STAR_FILL = 'pi pi-star-fill';
    public static readonly STEP_BACKWARD = 'pi pi-step-backward';
    public static readonly STEP_BACKWARD_ALT = 'pi pi-step-backward-alt';
    public static readonly STEP_FORWARD = 'pi pi-step-forward';
    public static readonly STEP_FORWARD_ALT = 'pi pi-step-forward-alt';
    public static readonly STOP = 'pi pi-stop';
    public static readonly STOP_CIRCLE = 'pi pi-stop-circle';
    public static readonly STOPWATCH = 'pi pi-stopwatch';
    public static readonly SUN = 'pi pi-sun';
    public static readonly SYNC = 'pi pi-sync';
    public static readonly TABLE = 'pi pi-table';
    public static readonly TABLET = 'pi pi-tablet';
    public static readonly TAG = 'pi pi-tag';
    public static readonly TAGS = 'pi pi-tags';
    public static readonly TELEGRAM = 'pi pi-telegram';
    public static readonly TH_LARGE = 'pi pi-th-large';
    public static readonly THUMBS_DOWN = 'pi pi-thumbs-down';
    public static readonly THUMBS_DOWN_FILL = 'pi pi-thumbs-down-fill';
    public static readonly THUMBS_UP = 'pi pi-thumbs-up';
    public static readonly THUMBS_UP_FILL = 'pi pi-thumbs-up-fill';
    public static readonly TICKET = 'pi pi-ticket';
    public static readonly TIMES = 'pi pi-times';
    public static readonly TIMES_CIRCLE = 'pi pi-times-circle';
    public static readonly TRASH = 'pi pi-trash';
    public static readonly TRUCK = 'pi pi-truck';
    public static readonly TWITTER = 'pi pi-twitter';
    public static readonly UNDO = 'pi pi-undo';
    public static readonly UNLOCK = 'pi pi-unlock';
    public static readonly UPLOAD = 'pi pi-upload';
    public static readonly USER = 'pi pi-user';
    public static readonly USER_EDIT = 'pi pi-user-edit';
    public static readonly USER_MINUS = 'pi pi-user-minus';
    public static readonly USER_PLUS = 'pi pi-user-plus';
    public static readonly USERS = 'pi pi-users';
    public static readonly VERIFIED = 'pi pi-verified';
    public static readonly VIDEO = 'pi pi-video';
    public static readonly VIMEO = 'pi pi-vimeo';
    public static readonly VOLUME_DOWN = 'pi pi-volume-down';
    public static readonly VOLUME_OFF = 'pi pi-volume-off';
    public static readonly VOLUME_UP = 'pi pi-volume-up';
    public static readonly WALLET = 'pi pi-wallet';
    public static readonly WHATSAPP = 'pi pi-whatsapp';
    public static readonly WIFI = 'pi pi-wifi';
    public static readonly WINDOW_MAXIMIZE = 'pi pi-window-maximize';
    public static readonly WINDOW_MINIMIZE = 'pi pi-window-minimize';
    public static readonly WRENCH = 'pi pi-wrench';
    public static readonly YOUTUBE = 'pi pi-youtube';
}
